import axios from 'axios'
import { getAuth, getIdToken } from 'firebase/auth'
import type { WithId } from 'fitify-types/src/types/common'
import type { EmailCampaign } from 'fitify-types/src/types/email-campaigns'

export const axiosInstance = axios.create({
  baseURL: '/api',
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
})

axiosInstance.interceptors.request.use(
  async (config) => {
    const auth = getAuth()

    if (auth.currentUser) {
      const token = await getIdToken(auth.currentUser)
      config.headers['Authorization'] = token
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const getCampaigns = async () => {
  const response =
    await axiosInstance.get<WithId<EmailCampaign>[]>('/campaigns')
  return response.data
}

export const getEmailTemplateIds = async () => {
  const response = await axiosInstance.get<string[]>('/template-ids')
  return response.data
}
